import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["card"],
      _excluded2 = ["card"],
      _excluded3 = ["noPadding"],
      _excluded4 = ["card"],
      _excluded5 = ["noPadding"],
      _excluded6 = ["card", "darker"],
      _excluded7 = ["noPadding"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { memoizeDeep, safeMerge } from "../common/utilities";
const setRoot = memoizeDeep(function (_ref) {
  let {
    container,
    width,
    height,
    theme,
    noBoxShadow,
    noPadding,
    borders,
    floatingHeader,
    onClick
  } = _ref;
  let cssRoot = {};

  const _container$root = container.root,
        {
    card: cardRoot
  } = _container$root,
        commonRoot = _objectWithoutProperties(_container$root, _excluded);

  cssRoot = _objectSpread({
    width,
    height
  }, commonRoot);

  if (theme === "card") {
    cssRoot = safeMerge(cssRoot, cardRoot);
  } else {
    cssRoot = safeMerge(cssRoot, container.theme[theme]);
  }

  if (noPadding) {
    cssRoot = safeMerge(cssRoot, container.modifiers.noPadding);
  }

  if (floatingHeader && theme !== "transparent" || onClick) {
    /**
     * If the header is floating but not transparent, or if the
     * container is clickable, borders and boxShadow are not
     * configurable and the default values are used.
     */
    cssRoot = safeMerge(cssRoot, container.modifiers.borders.default);
    cssRoot = safeMerge(cssRoot, container.modifiers.shadow.default);
  } else {
    cssRoot = safeMerge(cssRoot, container.modifiers.borders[borders]);
    cssRoot = noBoxShadow ? safeMerge(cssRoot, container.modifiers.shadow.none) : safeMerge(cssRoot, container.modifiers.shadow.default);
  }

  return cssRoot;
});
const setHeader = memoizeDeep(function (_ref2) {
  let {
    container,
    theme,
    noPadding
  } = _ref2;
  let cssHeader = {};

  const _container$header = container.header,
        {
    card: {
      noPadding: noPaddingHeader
    }
  } = _container$header,
        cardHeader = _objectWithoutProperties(_container$header.card, _excluded3),
        commonHeader = _objectWithoutProperties(_container$header, _excluded2);

  cssHeader = commonHeader;

  if (theme === "card") {
    cssHeader = safeMerge(cssHeader, cardHeader);

    if (noPadding) {
      cssHeader = safeMerge(cssHeader, noPaddingHeader);
    }
  }

  return cssHeader;
});
const setBody = memoizeDeep(function (_ref3) {
  let {
    container,
    theme,
    noPadding
  } = _ref3;
  let cssBody = {};

  const _container$body = container.body,
        {
    card: {
      noPadding: noPaddingBody
    }
  } = _container$body,
        cardBody = _objectWithoutProperties(_container$body.card, _excluded5),
        commonBody = _objectWithoutProperties(_container$body, _excluded4);

  cssBody = commonBody;

  if (theme === "card") {
    cssBody = safeMerge(cssBody, cardBody);

    if (noPadding) {
      cssBody = safeMerge(cssBody, noPaddingBody);
    }
  }

  return cssBody;
});
const setFooter = memoizeDeep(function (_ref4) {
  let {
    container,
    theme,
    noPadding
  } = _ref4;
  let cssFooter = {};

  const _container$footer = container.footer,
        {
    card: {
      noPadding: noPaddingFooter
    },
    darker: darkerFooter
  } = _container$footer,
        cardFooter = _objectWithoutProperties(_container$footer.card, _excluded7),
        commonFooter = _objectWithoutProperties(_container$footer, _excluded6);

  cssFooter = commonFooter;

  if (theme === "card") {
    cssFooter = safeMerge(cssFooter, cardFooter);

    if (noPadding) {
      cssFooter = safeMerge(cssFooter, noPaddingFooter);
    }
  }

  if (theme === "darker") {
    cssFooter = safeMerge(cssFooter, darkerFooter);
  }

  return cssFooter;
});
export default function (_ref5) {
  var _internalTheme$compon;

  let {
    internalTheme,
    theme,
    noBoxShadow,
    noPadding,
    width,
    height,
    borders,
    floatingHeader,
    onClick
  } = _ref5;
  let cssRoot = {},
      cssHeader = {},
      cssBody = {},
      cssFooter = {};
  const container = internalTheme === null || internalTheme === void 0 ? void 0 : (_internalTheme$compon = internalTheme.components) === null || _internalTheme$compon === void 0 ? void 0 : _internalTheme$compon.container;

  if (container) {
    cssHeader = setHeader({
      container,
      theme,
      noPadding
    });
    cssBody = setBody({
      container,
      theme,
      noPadding
    });
    cssFooter = setFooter({
      container,
      theme,
      noPadding
    });
    cssRoot = setRoot({
      container,
      width,
      height,
      theme,
      noBoxShadow,
      noPadding,
      borders,
      floatingHeader,
      onClick
    });
  }

  return {
    cssRoot,
    cssHeader,
    cssBody,
    cssFooter
  };
}